import { apiFetch } from "../client";

export function getCopturePrices() {
  return apiFetch("/copture/prices/", {
    method: "GET",
  });
}

export function getDroneCheckout({ refs, package_id, fmp_id, coupon_code, extra_data }) {
  return apiFetch("/copture/checkout/", {
    method: "POST",
    body: JSON.stringify({
      refs,
      package: package_id,
      fmp: fmp_id,
      coupon_code,
      extra_data,
    }),
  });
}

export function getDroneCouponDiscount({
  refs,
  package_id,
  forest_management_plan_id,
  coupon_code,
}) {
  return apiFetch("/copture/coupon-discount/", {
    method: "POST",
    body: JSON.stringify({
      refs,
      package_id,
      forest_management_plan_id,
      coupon_code,
    }),
  });
}
